/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Field SVG Icons
 */
import { ReactComponent as AddressField } from "assets/images/icons/fields/location-field.svg";
import { ReactComponent as BooleanField } from "assets/images/icons/fields/boolean-field.svg";
import { ReactComponent as Component } from "assets/images/icons/fields/component-field.svg";
import { ReactComponent as ComponentList } from "assets/images/icons/fields/component-list-field.svg";
import { ReactComponent as CurrencyField } from "assets/images/icons/fields/currency-field.svg";
import { ReactComponent as DateOnlyField } from "assets/images/icons/fields/date-only-field.svg";
import { ReactComponent as DateTimeField } from "assets/images/icons/fields/calendar-field.svg";
import { ReactComponent as DecimalField } from "assets/images/icons/fields/decimal-field.svg";
import { ReactComponent as DocumentField } from "assets/images/icons/fields/document-field.svg";
import { ReactComponent as EmailField } from "assets/images/icons/fields/email-field.svg";
import { ReactComponent as EmbedField } from "assets/images/icons/fields/embed-field.svg";
import { ReactComponent as EnumField } from "assets/images/icons/fields/enum-field.svg";
import { ReactComponent as HeadingField } from "assets/images/icons/fields/heading-field.svg";
import { ReactComponent as ImageField } from "assets/images/icons/fields/image-field.svg";
import { ReactComponent as ImagesField } from "assets/images/icons/fields/image-list-field.svg";
import { ReactComponent as JSONField } from "assets/images/icons/fields/json-field.svg";
import { ReactComponent as LinkField } from "assets/images/icons/fields/link-field.svg";
import { ReactComponent as LocationField } from "assets/images/icons/fields/location-field.svg";
import { ReactComponent as MultiLineField } from "assets/images/icons/fields/text-multiline-field.svg";
import { ReactComponent as NumberField } from "assets/images/icons/fields/number-field.svg";
import { ReactComponent as PhoneNumberField } from "assets/images/icons/fields/phone-field.svg";
import { ReactComponent as RichText } from "assets/images/icons/fields/rich-text-field.svg";
import { ReactComponent as TextField } from "assets/images/icons/fields/text-field.svg";
import { ReactComponent as TimeOnlyField } from "assets/images/icons/fields/time-only-field.svg";
import { ReactComponent as URLField } from "assets/images/icons/fields/url-field.svg";

// from questions

const fields = {
    AddressField,
    BooleanField,
    Component,
    ComponentList,
    CurrencyField,
    DateTimeField,
    DateOnlyField,
    DecimalField,
    EmailField,
    EmbedField,
    EnumField,
    ImageField,
    ImagesField,
    TextField,
    MultiLineField,
    RichText,
    NumberField,
    TimeOnlyField,
    LocationField,
    DocumentField,
    LinkField,
    URLField,
    HeadingField,
    PhoneNumberField,
    JSONField,
};

export { fields };
